module.exports = __webpack_public_path__ + "static/media/forgot-password-img.4da2a3db.png";